"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitResultBase = void 0;
const Entities_1 = require("../../Entities");
class SubmitResultBase extends Entities_1.RequestHandler {
    castPayloadV2(payload) {
        const castPayload = payload;
        if (castPayload.result === undefined || castPayload.resultType === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    castPayloadV3(payload) {
        const castPayload = payload;
        if (castPayload.result === undefined || castPayload.resultType === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 2, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'SUBMIT_RESULTS';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 2) {
                const { description, result, resultType } = this.castPayloadV2(payload);
                this.action(resultType, result, description);
            }
            else if (version === 3) {
                const { description, result, resultType } = this.castPayloadV3(payload);
                this.action(resultType, result, description);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.SubmitResultBase = SubmitResultBase;
